import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-all duration-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-[hsl(var(--primary))] text-primary-foreground shadow-[0_3px_0_hsl(var(--primary-dark)),0_4px_8px_hsl(var(--primary)/0.25)]",
        secondary:
          "border-transparent bg-white/[0.08] text-foreground shadow-[0_2px_0_rgba(0,0,0,0.2)]",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow-[0_3px_0_hsl(0,84%,45%),0_4px_8px_hsl(0,84%,60%,0.25)]",
        outline: 
          "border-2 border-white/20 text-foreground shadow-[0_2px_0_rgba(255,255,255,0.05)]",
        success:
          "border-transparent bg-emerald-500/20 text-emerald-400 shadow-[0_2px_0_rgba(16,185,129,0.2)]",
        warning:
          "border-transparent bg-amber-500/20 text-amber-400 shadow-[0_2px_0_rgba(245,158,11,0.2)]",
        info:
          "border-transparent bg-blue-500/20 text-blue-400 shadow-[0_2px_0_rgba(59,130,246,0.2)]",
        vehicle:
          "border-transparent bg-[hsl(var(--primary))]/20 text-[hsl(var(--primary))] shadow-[0_2px_0_hsl(var(--primary)/0.2)]",
        category:
          "border-transparent bg-[hsl(var(--accent))]/20 text-[hsl(var(--accent))] shadow-[0_2px_0_hsl(var(--accent)/0.2)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
